import { render, staticRenderFns } from "./CropBreedListItem.vue?vue&type=template&id=cc0b5bf8&scoped=true&"
import script from "./CropBreedListItem.vue?vue&type=script&lang=js&"
export * from "./CropBreedListItem.vue?vue&type=script&lang=js&"
import style0 from "./CropBreedListItem.vue?vue&type=style&index=0&id=cc0b5bf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0b5bf8",
  null
  
)

export default component.exports